import { MOBILE_SCROLL_MQ } from "@/mobileScrollHub";

/**
 * IntersectionObserver gate — skip scroll-driven work when section is off-screen
 * (avoids layout reads while scrolling the hero).
 */
export function observeSectionActive(sectionEl, onChange, rootMargin = "15% 0px") {
  if (!sectionEl) return () => {};

  const mq = window.matchMedia(MOBILE_SCROLL_MQ);
  if (!mq.matches) {
    onChange(true);
    return () => {};
  }

  if (typeof IntersectionObserver === "undefined") {
    onChange(true);
    return () => {};
  }

  onChange(false);

  const io = new IntersectionObserver(
    ([entry]) => {
      onChange(entry.isIntersecting);
    },
    { rootMargin, threshold: 0 },
  );
  io.observe(sectionEl);

  return () => io.disconnect();
}
